export const AFFILIATE_APPLICATION_MAILTO =
  'mailto:walker@atrivial.com?subject=Atrivial%20Affiliates%20%E2%80%94%20count%20me%20in';
